<template>

    <div>
        <div class="modal fade" style="display: block; opacity: 1;" tabindex="-1" id="modalEditVehicle">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <a @click="closeModal" href="javascript:void(0)" class="close" data-dismiss="modal" aria-label="Close">
                    <em class="icon ni ni-cross"></em>
                </a>
                <div class="modal-header">
                    <h5 class="modal-title">{{ translations.forms.vehicle.title_edit }}</h5>
                </div>
                <div class="modal-body">

                    <div id="form-edit-competitor">

                        <input type="hidden" name="vehicle_id" id="vehicle_id" v-model="vehicleInfo.id" />

                        <div class="form-group row">
                            <div class="col">
                                <label for="brand">{{ translations.forms.vehicle.brand }}*</label>
                                <input id="brand" v-model="vehicleInfo.brand" name="brand" type="text" required="required" class="form-control">
                            </div>
                            <div class="col">
                                <label for="type">{{ translations.forms.vehicle.type }}*</label>
                                <input id="type" v-model="vehicleInfo.type" name="type" type="text" required="required" class="form-control">
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col">
                                <label for="build_year">{{ translations.forms.vehicle.build_year }}*</label>
                                <input id="build_year" v-model="vehicleInfo.build_year" name="build_year" type="number" required="required" class="form-control">
                            </div>
                            <div class="col">
                                <label for="chassis_number">{{ translations.forms.vehicle.chassis_number }}*</label>
                                <input id="chassis_number" v-model="vehicleInfo.chassis_number" name="chassis_number" type="text" required="required" class="form-control">
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col">
                                <label for="license_plate">{{ translations.forms.vehicle.license_plate }}*</label>
                                <input id="license_plate" v-model="vehicleInfo.license_plate" name="license_plate" type="text" required="required" class="form-control">
                            </div>
                        </div>

                    </div>

                </div>
                <div class="modal-footer bg-light">
                    <button type="button" @click="saveVehicle" class="btn btn-success">{{ translations.forms.competitor.save }}</button>
                </div>
            </div>
        </div>
    </div>
        <div class="modal-backdrop fade show"></div>
    </div>

</template>

<script>
    export default {
        name: 'editVehicleModal',
        props: [
            'vehicle',
            'translations',
        ],

        data() {
            return {
                vehicleInfo: {},
            }
        },

        mounted() {
            this.vehicleInfo = this.vehicle;
        },

        methods: {
            saveVehicle() {
                this.$emit('onSave', this.vehicleInfo);
            },
            closeModal() {
                this.$emit('closeModal');
            }
        }
    }
</script>
